import { render, staticRenderFns } from "./NoSearchResultsMessage.vue?vue&type=template&id=47dcb21c&scoped=true&"
import script from "./NoSearchResultsMessage.vue?vue&type=script&lang=js&"
export * from "./NoSearchResultsMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dcb21c",
  null
  
)

export default component.exports